import React from 'react';

import Doc from './assets/Doc.png';
import Cart from './assets/Cart.png';
import Puzzle from './assets/PuzzleHome.png';
import { ASK_EMAIL, OPERATOR_EMAIL, PARTNER_EMAIL, PR_EMAIL } from '../../constants';


export const data = {
    advantages: [
        {
            title: <>Доступная инфраструктура без&nbsp;посредников</>,
            text: (
                <>
                    Привлечь средства можно 24/7, а&nbsp;все функции биржи,
                    депозитария, клирингового центра и брокера выполнит сама платформа
                </>
            ),
        },
        {
            title: <>Низкие расходы на&nbsp;администрирование исполнения обязательств</>,
            text: 'Осуществляется автоматически согласно смарт-контракту. Ошибки и человеческий фактор — исключены',
        },
        {
            title: 'Моментальные расчеты',
            text: 'Реализованы по принципу «поставка против платежа» (при условии использования номинальных счетов)',
        },
        {
            title: 'НДС не облагается',
            text: (
                <>
                    Большинство операций с ЦФА освобождены от НДС,
                    облагаются только некоторые сделки с&nbsp;гибридными ЦФА
                </>
            ),
        },
        {
            title: <>Привлечение капитала под&nbsp;широкий перечень активов</>,
            text: 'Могут быть токенизированы и введены в оборот ранее низколиквидные активы (товары, услуги, объекты прав)',
        },
        {
            title: 'Гибкие условия выпуска, обращения и погашения',
            text: 'С помощью смарт-контрактов можно реализовать любой сценарий жизненного цикла актива. Например, ЦФА со сроком обращения несколько дней, что делает его отличным источником краткосрочной ликвидности',
        },
        {
            title: 'Привлечение инвесторов с любым уровнем дохода',
            text: 'Выпуск ЦФА может состоять из большого числа недорогих активов, что позволяет привлечь не только крупных, но и небольших инвесторов',
        },
        {
            title: 'Отсутствие барьера для МСБ',
            text: 'Разместить ЦФА могут любые компании и ИП вне зависимости от размера годовой выручки. Также отсутствуют ограничения по объему выпуска, наличию кредитного рейтинга и поручителя',
        },
    ],
    ideas: [
        {
            title: 'Цифровые облигации',
            text: (
                <>
                    Выпуск корпоративных и государственных долговых инструментов
                    быстрее и дешевле чем на&nbsp;традиционном фондовом рынке
                </>
            ),
            image: Doc,
        },
        {
            title: 'Маркетплейс финансирования',
            text: 'Токенизация кредиторской задолженности покупателей и дебиторской задолженности поставщиков',
            image: Cart,
        },
        {
            title: 'Цифровые квадратные метры',
            text: (
                <>
                    Быстрое и дешевое привлечение финансирования для девелоперов.
                    Вложения в недвижимость с&nbsp;низким порогом входа для инвесторов
                </>
            ),
            image: Puzzle,
        },
    ],
    toKnow: [
        'ЦФА не являются платежным средством',
        'Реализуется интеграция платформы ЦФА ХАБ с платформой цифрового рубля',
        'ЦФА выпускаются эмитентами только на платформах операторов, включенных в реестр Банка России',
        <>ЦФА нельзя приобрести за&nbsp;криптовалюту</>,
    ],
    issuerCompanies: [
        'Крупные корпорации',
        'Средний и малый бизнес',
        'Индивидуальные предприниматели',
    ],
    releaseDfaSteps: [
        <>
            Подбираем ЦФА под ваши задачи. Используем готовый смарт-контракт или разрабатываем новый
        </>,
        <>
            Запрашиваем документы для&nbsp;проведения идентификации.
            Открываем личный кабинет на&nbsp;платформе
        </>,
        'Проверяем заявку на выпуск и публикуем «Решение о выпуске ЦФА»',
        'Собираем заявки от инвесторов. Выпускаем ЦФА',
    ],
    clients: {
        unqualified: {
            title: 'Неквалифицированные инвесторы',
            text: (
                <>
                    Как и в случае с традиционными инструментами, есть ряд ограничений.
                    Физлица&nbsp;без статуса могут вкладывать средства, например,
                    в долговые ЦФА наиболее надежных эмитентов, доходность и сроки погашения
                    которых фиксируются заранее. Также им доступны некоторые типы гибридных ЦФА с
                    привязкой к реальным активам и цифровые права участия в капитале непубличных АО.
                    <br /><br />
                    Регистрируйтесь на ЦФА ХАБ и получайте доступ к новым цифровым инструментам.
                    Если захотите расширить свои инвестиционные возможности — подскажем,
                    как это сделать по правилам
                </>
            ),
        },
        arr: [
            {
                title: 'Квалифицированные инвесторы',
                text: 'Структурные продукты любой сложности, разрешенные российским законодательством',
            },
            {
                title: 'Банки и другие финансовые организации',
                text: 'Диверсификация кредитного портфеля и доступ к новым клиентам',
            },
            {
                title: 'Нерезиденты',
                text: 'Для иностранных клиентов разрешена удаленная идентификация',
            },
            {
                title: 'Нефинансовый сектор, включая ИП',
                text: (
                    <>
                        Размещение свободных средств под&nbsp;ставки, превышающие депозитные.
                        Для любого бизнеса без ограничений по объему выручки
                    </>
                ),
            },
        ],
    },
    helps: [
        {
            title: 'Операторам обмена',
            text: 'Предлагаем взаимодействие через API для организации на вашей стороне всех доступных сделок с ЦФА: эмиссия и первичное приобретение, купля-продажа на вторичном рынке',
        },
        {
            title: 'Номинальным держателям с лицензией депозитария',
            text: 'Подготовили API для учета ЦФА, права на которые принадлежат вашим клиентам',
        },
        {
            title: 'Банкам и доверительным управляющим, брокерам и инвестиционным советникам, управляющим компаниям и депозитариям, инвестиционным платформам и агентам',
            text: (
                <>
                    Платим за лидогенерацию сделок.
                    Создаем брендированные витрины или интегрируемся с&nbsp;вашими приложениями.
                    Статус оператора обмена не требуется
                </>
            ),
        },
    ],
    additional: [
        'Юридический консалтинг',
        'Структурирование выпусков ЦФА',
        'Разработка ПО (личные кабинеты, витрины, маркетплейсы и др.)',
        'Разработка смарт-контрактов',
        'Разработка API',
    ],
    documents: [
        {
            name: 'Правила ИС ООО «Блокчейн Хаб» (версия от 27.07.2023)',
            // size: 399,
            link: './rules.pdf',
        },
        {
            name: 'Устав ООО «Блокчейн Хаб»',
            link: './Устав ООО Блокчейн Хаб.pdf',
        },
        {
            name: 'Политика информационной безопасности',
            link: './Политика_информационной_безопасности_ООО_Блокчейн_Хаб.pdf',
        },
        {
            name: 'Лицензионный договор',
            link: './Лицензионный договор.pdf',
        },
        {
            name: 'Тарифы на уплату лицензионного вознаграждения',
            link: './Тарифы_на_уплату_лицензионного_вознаграждения.pdf',
        },
        {
            name: 'Положение о квалифицированных инвесторах',
            link: './Положение о квалифицированных инвесторах ООО Блокчейн Хаб.pdf',
        },
        {
            name: 'Требования к программному обеспечению',
            link: './Требования к программному обеспечению для работы Пользователя в Личном кабинете.pdf',
        },
        {
            name: 'Заявление ЮЛ, ИП о присоединении к правилам',
            link: './Заявление ЮЛ, ИП о присоединении к правилам.docx',
        },
        {
            name: 'Заявление ЮЛ, ИП о присоединении к лицензионному договору',
            link: './Заявление ЮЛ, ИП о присоединении к лицензионному договору.docx',
        },
        {
            name: 'Перечень документов для регистрации ЮЛ',
            link: './Перечень документов для регистрации ЮЛ.pdf',
        },
        {
            name: 'Перечень документов для регистрации ИП',
            link: './Перечень документов для регистрации ИП.pdf',
        },
        {
            name: 'Анкета в целях идентификации ЮЛ',
            link: './Анкета в целях идентификации ЮЛ.docx',
        },
        {
            name: 'Анкета в целях идентификации ИП',
            link: './Анкета в целях идентификации ИП.docx',
        },
        {
            name: 'Анкета в целях идентификации ФЛ',
            link: './Анкета в целях идентификации ФЛ.docx',
        },
        {
            name: 'Анкета в целях идентификации ИСБОЮЛ',
            link: './Анкета в целях идентификации ИСБОЮЛ.docx',
        },
        {
            name: 'Форма доверенности представителя ЮЛ, ИП',
            link: './Форма доверенности представителя ЮЛ, ИП.docx',
        },
        {
            name: 'Решение ПАО МТС о выпуске ЦФА № 02 от 12.12.2023',
            link: './Решение ПАО МТС о выпуске ЦФА № 02 от 12.12.2023.pdf',
        },
        {
            name: 'Уведомление о признании выпуска ЦФА состоявшимся ПАО «МТС», решение №2',
            link: './Уведомление_о_признании_выпуска_ЦФА_состоявшимся_МТС.pdf',
        },
    ],
    contacts: [
        {
            email: ASK_EMAIL,
            text: 'Выпуск и покупка ЦФА',
        },
        {
            email: OPERATOR_EMAIL,
            text: 'Информационная поддержка пользователей',
        },
        {
            email: PARTNER_EMAIL,
            text: 'Партнерская программа',
        },
        {
            email: PR_EMAIL,
            text: 'для СМИ',
        },
    ],
};
